var base = require('settings/invoices/update-extra-billing-information');

Vue.component('spark-update-extra-billing-information', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/invoices/update-extra-billing-information.js